import request from "@/utils/request";
import {exportFile} from "@/api/common";

// fba货件

export function getFbaShipmentPage(params) {
  return request.post(`/supply/shipment/page`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getListingLabelsInfo(params) {
  return request.get(`/supply/shipment/getListingLabelsInfo`, {params})
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getPrintListingLabelsInfo(params) {
  return request.get(`/supply/shipment/getPrintListingLabelsInfo`, {params})
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function deleteFbaShipment(id) {
  return request.delete(`/supply/shipment?id=${id}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function syncFbaShipment(params) {
  return request.post(`/supply/shipment/syncShipment`, params);
}

export function getPageTypes() {
  return request.get(`/supply/shipment/getPageTypes`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getFbaShipment(id) {
  return request.get(`/supply/shipment/getById/${id}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getFbaShipmentItems(params) {
  return request.post(`/supply/shipment/getShipmentItem`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getInventoryReceipts(params) {
  return request.post(`/supply/shipment/getInventoryReceipts`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getShipmentProductPage(params) {
  return request.post(`/supply/shipment/shipmentProductPage`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getShipmentPageTypes() {
  return request.get(`/supply/shipment/getPageTypes`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function printShipmentBoxMark(params) {
  return request.post(`/supply/shipment/printBoxMark`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function updateFbaShipment(params) {
  return request.post(`/supply/shipment/updateShipment`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function uploadTransportDetails(params) {
  return request.post(`/supply/shipment/uploadTransportDetails`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function markFbaShipment(id) {
  return request.post(`/supply/shipment/markShipment?id=${id}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getTransportCarrierNames(params) {
  return request.get(`/supply/shipment/getTransportCarrierNames`, {params})
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function generatePackListTemplate(params) {
  return exportFile('/supply/shipment/generatePackListTemplate', params);
}

export function getCountryByWarehouseId(params) {
  return request.get(`/supply/shipment/countryComboboxByWarehouseId`, {params})
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function importShipmentProduct(params) {
  return request.post(`/supply/shipment/importShipmentProduct`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function previewFbaShipment(params) {
  return request.post(`/supply/shipment/previewShipment`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getShipFromAddress(params) {
  return request.get(`/supply/shipment/getShipFromAddress`, {params})
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function createFbaShipment(params) {
  return request.post(`/supply/shipment/createShipment`, params);
}

export function uploadShipmentPackList(params) {
  return request.post(`/supply/shipment/uploadPackList`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function getPackListFeedResult(id) {
  return request.post(`/supply/shipment/getPackListFeedResult?id=${id}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

// 物流商

export function getLogisticsOptions(params) {
  return request.get(`/supply/logistics/select`, params)
    .then((res) => Promise.resolve(res.data));
}

export function getLogisticsPage(params) {
  return request.post(`/supply/logistics/page`, params)
    .then((res) => Promise.resolve(res.data));
}

export function addLogisticsProvider(params) {
  return request.post(`/supply/logistics`, params);
}

export function enableLogisticsProvider(ids) {
  return request.put(`/supply/logistics/enable?ids=${ids}`);
}

export function disableLogisticsProvider(ids) {
  return request.put(`/supply/logistics/disable?ids=${ids}`);
}

export function deleteLogisticsProvider(ids) {
  return request.delete(`/supply/logistics?ids=${ids}`);
}

export function updateLogisticsProvider(params) {
  return request.put(`/supply/logistics`, params);
}

export function getLogisticsProvider(id) {
  return request.get(`/supply/logistics/${id}`)
    .then(res => Promise.resolve(res.data));
}

export function importLogisticsProvider(attachmentId) {
  return request.post(`/supply/logistics/import/supplier?attachmentId=${attachmentId}`);
}

// 头程物流

export function getLogisticsTransportPage(params) {
  return request.post(`/supply/transport/page`, params)
    .then(res => res.data);
}

export function getLogisticsTransport(id) {
  return request.get(`/supply/transport/${id}`)
    .then(res => res.data);
}

export function addLogisticsTransport(params) {
  return request.post(`/supply/transport/save`, params);
}

export function checkTransportName(params) {
  return request.get(`/supply/transport/checkTransportName`, {params})
    .then(res => res.data);
}

export function updateLogisticsTransport(params) {
  return request.put(`/supply/transport/update`, params);
}

export function verifyPrescriptionDelete(id) {
  return request.delete(`supply/transport/verifyPrescription/delete/${id}`,{});
}

export function deleteLogisticsTransport(params) {
  return request.delete(`/supply/transport/delete`, {params});
}

export function updateLogisticsTransportStatus(params) {
  return request.put(`/supply/transport/updateStatus`, null, {params});
}


// 物流时效
export function getLogisticsTransportPrescriptionPage(params) {
  return request.post(`/supply/transportPrescription/page`, params)
    .then(res => res.data);
}

// 发货单
export function getGenerateShipNoteProductItem(shipmentIds) {
  return request.get(`/supply/shipNote/generateShipNoteProductItem?shipmentIds[]=${shipmentIds}`)
    .then(res => res.data);
}

export function getShipNotePage(params) {
  return request.post(`/supply/shipNote/page`, params)
    .then(res => res.data);
}

export function getShipNoteDetail(id) {
  return request.get(`/supply/shipNote/${id}`)
    .then(res => res.data);
}

export function generateSaveWaitShipped(params) {
  return request.post(`/supply/shipNote/saveWaitShipped`, params);
}

export function generateSaveShipped(params) {
  return request.post(`/supply/shipNote/saveShipped`, params);
}

export function updateShipNote(params) {
  return request.put(`/supply/shipNote/update`, params);
}

export function getTransportSelect(params) {
  return request.get(`/supply/transport/queryTransport`, params)
    .then(res => res.data);
}

export function getPreviewShareResult(params) {
  return request.post(`/supply/shipNoteLogisticsFeeShare/previewShareResult`, params)
    .then(res => res.data);
}

export function shipNoteAbolished(params) {
  return request.put(`/supply/shipNote/shipNoteAbolished`, params);
}

export function shipNoteFinish(id) {
  return request.get(`/supply/shipNote/shipNoteFinish?id=${id}`)
    .then(res => res.data);
}

export function getInputLogisticsFee(code) {
  return request.get(`/supply/shipNoteLogisticsFeeShare/inputLogisticsFee?shipNoteCode=${code}`)
    .then(res => res.data);
}

export function saveShipNoteLogisticsFeeShare(params) {
  return request.post(`/supply/shipNoteLogisticsFeeShare/save`, params);
}

export function updateShipNoteMemo(params) {
  return request.put(`/supply/shipNote/updateMemo`, params);
}

export function updateShipNoteTrackings(params) {
  return request.put(`/supply/shipNote/updateTrackings`, params);
}

export function updateShipNoteLogisticsMemo(params) {
  return request.put(`/supply/shipNote/updateLogisticsMemo`, params);
}

/**
 * 发货计划列表
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const getDeliveryPlanList = params => request.post(`/supply/shipPlan/page`, params).then(res => res.data)


/**
 * 发货计划列表 -- 查询最大装配量
 * @param sku
 * @param warehouseId
 * @returns {AxiosPromise<any>}
 */
export const getDeliveryMaxAssemblyQuantity = (sku,warehouseId) => request.get(`/supply/shipPlan/max/assemblyQuantity?sku=${sku}&warehouseId=${warehouseId}`).then(res => res.data)

/**
 * 获取发货计划商品标签列表
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getDeliveryListingLabelsInfo = params => request.post(`/supply/shipPlan/listingLabelsInfo`, params).then(res => res.data)

/**
 * 获取物流方式
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getTransportOption = params => request.post(`/supply/shipPlan/dropDown/transport`, params).then(res => res.data)

/**
 * 导入发货计划商品
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postImportProducts = (params,form) => request.post(`/supply/shipPlan/import?attachmentId=${params}`,form).then(res => res)

/**
 * 保存发货计划
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postSaveDeliveryPlan = params => request.post(`/supply/shipPlan/save`, params).then(res => res.data)

/**
 * 新增发货计划
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postAddDeliveryPlan = params => request.post(`/supply/shipPlan/add/arraignment`, params).then(res => res.data)

/**
 * 获取物流方式
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getDeliveryPlanTransportOption = params => request.get(`/supply/transport/transportSelect`, { params }).then(res => res.data)

/**
 * 提审
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postArraignmentDeliveryPlan = params => request.post(`/supply/shipPlan/arraignment`, params).then(res => res.data)

/**
 * 审核通过
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postReviewPass = params => request.post(`/supply/shipPlan/review/yes`, params).then(res => res.data)

/**
 * 审核驳回
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postReviewNoPass = params => request.post(`/supply/shipPlan/review/no`, params).then(res => res.data)
/**
 * 作废
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postReviewAbort = params => request.post(`/supply/shipPlan/abolished`, params).then(res => res.data)
/**
 * 根据选中商品查询发货计划
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postFetchSelectRows4Plan = params => request.post(`/supply/shipPlan/selectGoods4Plan`, params).then(res => res.data)

/**
 * 获取发货仓库下拉计算结果
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postWarehouseChangeInfo = params => request.post(`/supply/shipPlan/dropDown/warehouse`, params).then(res => res.data)

/**
 * 获取物流方式下拉计算结果
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postTransportChangeInfo = params => request.post(`/supply/shipPlan/dropDown/transport`, params).then(res => res.data)
/**
 * 修改发货计划批次备注
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postUpdateMemo = params => request.post(`/supply/shipPlan/update/memo`, params).then(res => res.data)



/**
 * 删除发货计划
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const deleteShipPlan = params => request.delete(`/supply/shipPlan/delete`, {data:params}).then(res => res.data)

/**
 * 获取发货批次详情
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getShipPlanDetail = id => request.post(`/supply/shipPlan/detail/${id}`).then(res => res.data)

/**
 * 获取发货批次详情
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getShipPlanQueryDetail = id => request.get(`/supply/shipPlan/queryDetail/${id}`).then(res => res.data)
/**
 * 标记完成
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postCompleteDeliveryPlan = params => request.post(`/supply/shipPlan/markComplete`, params).then(res => res.data)


/**
 * 发货计划-批量编辑
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postShipPlanPatchEdit = params => request.put(`/supply/shipPlan/batchEdit`, params).then(res => res.data)


/**
 * 发货计划-复制
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postShipPlanCopyQuery = params => request.post(`/supply/shipPlan/copyQuery`, params).then(res => res.data)


/**
 * 发货计划-修改查询
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postShipPlanBatchEditQuery = params => request.post(`/supply/shipPlan/batchEdit/show`, params).then(res => res.data)



/**
 * 发货计划-生成采购计划查询
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postShipPlanPurchasePlanQuery = params => request.post(`/supply/shipPlan/generate/purchasePlan`, params).then(res => res.data)

/**
 * 发货计划-调拨单生成查询
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postShipPlanGenerateTransfer = params => request.post(`/supply/shipPlan/generate/transfer`, params).then(res => res.data)

/**
 * 发货计划-创建货件查询
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postShipPlanGenerateShipment = params => request.post(`/supply/shipPlan/generate/shipment`, params).then(res => res.data)


export function shipPlanback(params) {
    return request.post(`/supply/shipPlan/shipPlan/back`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

/**
 * 录入物流跟踪号
 */
 export function shipmentLogistics(params) {
  return request.post(`/supply/shipmentLogistics/save`, params)
      .then((res) => {
          return Promise.resolve(res);
      })
}